import React from "react";

/**
 * Skeleton — animated placeholder block. Used for loading states in
 * v2 cards, lists, and drawer rows. Variants:
 *   - card (default): full v2 card-shaped placeholder
 *   - line: single-line shimmer (use `width` prop)
 *   - chip: small inline pill
 *   - row:  list-row shape with title + meta lines
 */

const Skeleton = ({ variant = "card", count = 1, width, height, testId }) => {
  const items = Array.from({ length: Math.max(1, count) }, (_, i) => i);
  return (
    <>
      {items.map((i) => (
        <span
          key={i}
          className={`sk sk--${variant}`}
          style={{
            ...(width != null ? { width: typeof width === "number" ? `${width}px` : width } : {}),
            ...(height != null ? { height: typeof height === "number" ? `${height}px` : height } : {}),
          }}
          data-testid={testId || `v2-sk-${variant}`}
          aria-hidden="true"
        />
      ))}
    </>
  );
};

export const SkeletonCardGrid = ({ count = 4, testId = "v2-sk-grid" }) => (
  <div className="home-grid" data-testid={testId} aria-hidden="true">
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className="home-card home-card--skeleton">
        <Skeleton variant="line" width="60%" />
        <Skeleton variant="line" width="90%" />
        <Skeleton variant="line" width="40%" />
      </div>
    ))}
  </div>
);

export const SkeletonRows = ({ count = 4, testId = "v2-sk-rows" }) => (
  <div className="sk-rows" data-testid={testId} aria-hidden="true">
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className="sk-row">
        <Skeleton variant="line" width="55%" />
        <Skeleton variant="line" width="85%" />
      </div>
    ))}
  </div>
);

export default Skeleton;
